import { UserEventNotificationPreferences } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultResponse } from "./types";

export interface UpdateUserEventNotificationPreferenceInput {
  event_type_id: number;
  channel_mail: boolean;
  channel_push: boolean;
}

export const userEventNotificationPreferenceService = {
  async index(platform: number = 1) {
    const response = await api.get<
      DefaultResponse<UserEventNotificationPreferences>
    >("notification_preference", {
      params: {
        platform,
      },
    });
    return response.data;
  },

  async update(data: UpdateUserEventNotificationPreferenceInput[]) {
    const formattedData = data.map((item) => ({
      event_type_id: String(item.event_type_id),
      to_send: 1,
      channel_mail: item.channel_mail ? 1 : 0,
      channel_push: item.channel_push ? 1 : 0,
    }));

    const response = await api.put("notification_preference", formattedData);
    return response.data;
  },

  async indexForUser(userId: number, platform: number = 1) {
    const response = await api.get<
      DefaultResponse<UserEventNotificationPreferences>
    >(`user/${userId}/notification_preference`, {
      params: {
        platform,
      },
    });
    return response.data;
  },

  async updateForUser(
    userId: number,
    data: UpdateUserEventNotificationPreferenceInput[],
  ) {
    const formattedData = data.map((item) => ({
      event_type_id: String(item.event_type_id),
      to_send: 1,
      channel_mail: item.channel_mail ? 1 : 0,
      channel_push: item.channel_push ? 1 : 0,
    }));

    const response = await api.put(
      `user/${userId}/notification_preference`,
      formattedData,
    );
    return response.data;
  },
};
